module.exports = __webpack_public_path__ + "img/check-blue.4a68e7fa.svg";